export class Patient {
  public name: string;
  public sex: string;
  public age: number;

}
